var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.99973C2.2498 5.83619 2.28448 5.67448 2.35173 5.52541C2.41899 5.37633 2.51726 5.24331 2.64 5.13523L8.216 0.229734C8.40077 0.0746886 8.63888 -0.00191121 8.87939 0.0163136C9.11991 0.0345385 9.34375 0.146141 9.50306 0.327259C9.66236 0.508376 9.74448 0.744632 9.73185 0.985508C9.71923 1.22638 9.61286 1.45276 9.4355 1.61623L4.5595 5.90573C4.54612 5.91747 4.53539 5.93192 4.52804 5.94813C4.5207 5.96434 4.5169 5.98194 4.5169 5.99973C4.5169 6.01753 4.5207 6.03513 4.52804 6.05134C4.53539 6.06755 4.54612 6.082 4.5595 6.09373L9.4355 10.3832C9.52979 10.4624 9.60731 10.5595 9.66351 10.669C9.7197 10.7785 9.75344 10.8982 9.76274 11.0209C9.77204 11.1436 9.75672 11.267 9.71766 11.3837C9.67861 11.5004 9.61661 11.6082 9.53532 11.7006C9.45403 11.793 9.35509 11.8682 9.2443 11.9219C9.13352 11.9755 9.01313 12.0065 8.89022 12.0129C8.7673 12.0194 8.64434 12.0012 8.52856 11.9594C8.41277 11.9176 8.30651 11.8532 8.216 11.7697L2.642 6.86573C2.51896 6.75746 2.42037 6.62424 2.35278 6.47493C2.28519 6.32562 2.25016 6.16363 2.25 5.99973Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clip-path", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.48f99703e9816cd1e544a0006d72487b.svg";
export { ForwardRef as ReactComponent };